module.exports = __webpack_public_path__ + "img/bg_six_top.0ab42f82.png";